'use client'

import { useCallback } from 'react'
import { useOptionalTenant } from '@/contexts/TenantContext'
import {
    BOOK_VISIT_DETAIL_HREF,
    BOOK_VISIT_SKU_ID,
    bookVisitHref,
} from '@/lib/routes/booking'

/**
 * Resolves the Book a visit href for the active tenant. A tenant's own book-visit SKU replaces
 * the General Medicine first-visit / follow-up split, which only applies with no tenant SKU.
 */
export function useBookVisitHref(): (hasCompletedAppointment?: boolean | null) => string {
    const tenantBookVisitHref = useOptionalTenant()?.constants?.sku?.bookVisitHref
    return useCallback(
        (hasCompletedAppointment?: boolean | null) => tenantBookVisitHref ?? bookVisitHref(hasCompletedAppointment),
        [tenantBookVisitHref],
    )
}

/** Detail page for the tenant's default bookable visit, or the GM video-visit fallback. */
export function useBookVisitDetailHref(): string {
    return useOptionalTenant()?.constants?.sku?.bookVisitDetailHref ?? BOOK_VISIT_DETAIL_HREF
}

/** SKU id for the tenant's default bookable visit, or the GM video-visit fallback. */
export function useBookVisitSkuId(): string {
    return useOptionalTenant()?.constants?.sku?.bookVisitSkuId ?? BOOK_VISIT_SKU_ID
}
